module.exports = __webpack_public_path__ + "static/img/pres-op--high-colour.a6b5a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/old-services/pres-op--high-colour.png
// module id = f9C7
// module chunks = 1